module.exports = __webpack_public_path__ + "static/img/19078D_1_R_20200820_LC.017cf5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19078D_1_R_20200820_LC.png
// module id = iWy5
// module chunks = 0